import React from 'react';
import componentStyles from './gameInfoCard.module.css';

const GameInfoCard = ({ betCardData }) => {
    // Extract team names and sport type
    const homeTeam = betCardData?.homeTeam || 'Home Team';
    const awayTeam = betCardData?.awayTeam || 'Away Team';
    const sportType = betCardData?.sportType || 'Sport';
    const upcomingEventDt = betCardData?.upcomingEventDt || 'TBD';
    const isPGA = ['pga', 'pga_tour', 'golf'].includes(String(sportType || '').toLowerCase());
    const matchupDisplay = betCardData?.matchup || betCardData?.matchUp || betCardData?.eventName || 'Event';

    // Generate team logos using Placehold.co
    const getTeamLogo = (teamName) => {
        const shortName = teamName?.split(' ').pop() || 'TEAM';
        return `https://placehold.co/60x60/1a1a1a/66ff00?text=${shortName}`;
    };

    return (
        <div className={componentStyles.gameInfoCard}>
            <div className={componentStyles.gameHeader}>
                <div className={componentStyles.sportBadge}>
                    {sportType}
                </div>
                <div className={componentStyles.gameDate}>
                    {upcomingEventDt}
                </div>
            </div>
            
            {isPGA ? (
                <div className={componentStyles.matchupContainer}>
                    <span className={componentStyles.matchupTitle}>{matchupDisplay}</span>
                </div>
            ) : (
                <div className={componentStyles.teamsContainer}>
                    <div className={componentStyles.teamSection}>
                        <img 
                            src={getTeamLogo(awayTeam)} 
                            alt={`${awayTeam} logo`}
                            className={componentStyles.teamLogo}
                        />
                        <div className={componentStyles.teamInfo}>
                            <span className={componentStyles.teamName}>{awayTeam}</span>
                            <span className={componentStyles.teamLabel}>Away</span>
                        </div>
                    </div>
                    
                    <div className={componentStyles.vsSection}>
                        <span className={componentStyles.vsText}>VS</span>
                    </div>
                    
                    <div className={componentStyles.teamSection}>
                        <img 
                            src={getTeamLogo(homeTeam)} 
                            alt={`${homeTeam} logo`}
                            className={componentStyles.teamLogo}
                        />
                        <div className={componentStyles.teamInfo}>
                            <span className={componentStyles.teamName}>{homeTeam}</span>
                            <span className={componentStyles.teamLabel}>Home</span>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default GameInfoCard; 
